import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-custom-checkbox-field',
  templateUrl: './custom-checkbox-field.component.html',
  styleUrls: ['./custom-checkbox-field.component.css']
})
export class CustomCheckboxFieldComponent {
  @Input() id: string;
  @Input() value: string;
  @Input() controlName: string;
  @Input() key: string;
  @Input() checked: boolean;
  @Input() form: FormGroup;
  @Input() hideErrors = false;
  @Output() setCheckStatus = new EventEmitter<boolean>();
  @Output() setCheckValue = new EventEmitter<string>();
  @ViewChild('error') error;

  checkStatus = false;
  checkValue = null;

  setChecked(data) {
    this.checkStatus = data.target.checked;
    this.checkValue = data.target.value;
    this.setCheckStatus.emit(this.checkStatus);
    this.setCheckValue.emit(this.checkValue);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/forms/custom-checkbox-field/custom-checkbox-field.component.ts